import { createModuleDescriptor } from '../../redux/module-descriptor';
import { createEntityDescriptor } from '../../redux/entity-descriptor';
import saga from './sagas';
import createIntlReducer from './reducer';
import selectors from './selectors';
import actions from './actions';

const intl = createModuleDescriptor('intl', {
  entities: [
    createEntityDescriptor('countries', {
      list: {
        url: '/api/countries/list.json',
        responseProjection: data => ({
          count: Object.entries(data).length,
          list: Object.entries(data).map(keyValue => ({ value: keyValue[0], label: keyValue[1] })),
        }),
      },
    }),
  ],
  createReducer: createIntlReducer,
  saga,
  selectors,
  actions,
});
export default intl;
